import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Menu, Dropdown, Label, Icon, Image, Message, Grid, Header, Button } from 'semantic-ui-react';

import { CtServiceShareChangeService } from 'containers';
import { Help } from 'components';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './ServiceShareSelect.css';
const cx = classNames.bind(styles);

class ServiceShareSelect extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { isAuth, shareInfo, myInfo } = this.props;
    const { handleOnClickSelectService } = this;

    let currentServiceName = defineMessages(formatMessage({ id: 'ServiceShareSelect_1', defaultMessage: '내 서비스' }));

    const otherService = [];
    for (let i = 0, l = shareInfo.length; i < l; i++) {
      const d = shareInfo[i];
      if (myInfo.userNo === d.userNo) {
        otherService.push({
          key: d.userServiceNo,
          content: <CtServiceShareChangeService isAuth={isAuth} shareInfo={d} myInfo={myInfo} />,
          value: d.serviceNo
        });
      }

      if (d.serviceNo === myInfo.serviceNo) {
        currentServiceName = d.serviceName;
      }
    }

    return (
      <div className={cx('share-select-box')}>
        <Menu>
          <Menu.Menu position="right">
            <Dropdown
              className={cx('share-select-dropdown')}
              inline
              floating
              selectOnBlur={false}
              // selectOnNavigation={false}
              options={otherService}
              defaultValue={myInfo.serviceNo}
              trigger={
                <Label size="large" as="a" className={cx('share-select-label')}>
                  {myInfo.serviceNo === myInfo.originalServiceNo ? (
                    <Image src="/img/headerShare/my-service.png" />
                  ) : (
                    <Image src="/img/headerShare/other-service.png" />
                  )}
                  <div
                    className={cx('label-content', myInfo.serviceNo === myInfo.originalServiceNo ? 'my-service' : '')}>
                    {currentServiceName}
                  </div>
                  <Image className={cx('arrow')} src="/img/headerShare/arrow.png" />
                </Label>
              }
            />
          </Menu.Menu>
        </Menu>
      </div>
    );
  }
}

ServiceShareSelect.propTypes = {
  shareInfo: PropTypes.array,
  myInfo: PropTypes.object
};
ServiceShareSelect.defaultProps = {
  shareInfo: [],
  myInfo: {}
};

export default injectIntl(ServiceShareSelect);



// WEBPACK FOOTER //
// ./src/script/components/share/ServiceShareSelect.js